import { render, staticRenderFns } from "./ClaimTypeField.vue?vue&type=template&id=7868a2bb"
import script from "./ClaimTypeField.vue?vue&type=script&lang=js"
export * from "./ClaimTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports